import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { settings } from 'src/settings';

@Injectable({
  providedIn: 'root',
})
export class OrderEmailService {
  constructor(private activatedRoute: ActivatedRoute) {}

  getEmailAddressForOrder(): string | null {
    const domain = this.activatedRoute.snapshot.queryParamMap.get('domain');
    if (!domain) {
      return null;
    }
    if (domain.includes('frost.is')) {
      return settings.frost;
    }
    if (domain.includes('gosens-koeltechniek.nl')) {
      return settings.gosens;
    }
    if (domain.includes('koledanmark.dk')) {
      return settings.koledanmark;
    }
    if (domain.includes('coldroom.dk')) {
      return settings.coldroomdk;
    }
    if (domain.includes('koelcelwinkel.nl')) {
      return settings.koelcelwinkel;
    }
    if (domain.includes('kingspan.com')) {
      return settings.kingspan;
    }
    if (domain.includes('kingspangroup.com')) {
      return settings.kingspangroup;
    }
    return null;
  }
}
